export default __webpack_public_path__ + "static/media/cypher.6d5616fd.jpeg";